export const EXTERNAL = 'External';

export const URGENT = 'Urgent';

export const MEMBER_REPRESENTATIVE = 'MemberRepresentative';

export const ENTITY_NAME = {
  Authorization: 'Authorization',
  AuthorizationServiceLocation: 'AuthorizationServiceLocationByProduct',
  AuthorizationByProduct: 'AuthorizationByProduct',
  AuthorizationCase: 'AuthorizationCase',
  ProductLine: 'ProductLine',
};

export const OTHER = 'other';
export const OTHER_1ST_OUTREACH = 'Other1stOutreach';
export const OTHER_2ND_OUTREACH = 'Other2ndOutreach';

export const INCOMPLETE_CATEGORY = 'Incomplete';

export const CODE_UNKNOWN = 'Unknown';

export const AUTH_STATUS = {
  Incomplete: 'Incomplete',
  Pending: 'Pending',
  Active: 'Active',
  Discharged: 'Discharged',
  Cancelled: 'Cancelled',
}

export const enum StaffingStatus {
  ConfirmationNeeded = 'Confirmation Needed',
  ManualStaffingInProgress = 'Manual Staffing in Progress',
  Staffed = 'Staffed',
  UnableToStaff = 'Unable to Staff',
  DMEPOSProviderNotFound = 'DMEPOS Provider Not Found',
  DMEPOSProviderOON = 'DMEPOS Provider OON',
  DMEPOSProviderSanction = 'DMEPOS Provider Sanction',
  UserIsHPCM = 'User is HPCM',
  OrderingProviderNotFound = 'Ordering Provider Not Found',
  OrderingProviderSanction = 'Ordering Provider Sanction',
}
